import {
  DRAWING_KIND_ANNET,
  DRAWING_KIND_ARKITEKT,
  DRAWING_KIND_KJOKKEN,
  DRAWING_KIND_VENTILASJON,
  DEFAULT_DRAWING_KIND,
} from "./drawingKinds";

/** Visual tokens for drawing types (list cards, structure dots, filters). */
export const DRAWING_KIND_STYLES = {
  [DRAWING_KIND_ARKITEKT]: {
    color: "#1F4BE0",
    bg: "#EEF2FE",
    border: "#C9D6FA",
  },
  [DRAWING_KIND_VENTILASJON]: {
    color: "#0F8C77",
    bg: "#E9F7F3",
    border: "#B7E4D8",
  },
  [DRAWING_KIND_KJOKKEN]: {
    color: "#B0561C",
    bg: "#FDF0E7",
    border: "#F0D0B4",
  },
  [DRAWING_KIND_ANNET]: {
    color: "#5B6472",
    bg: "#F1F3F6",
    border: "#D8DDE4",
  },
};

export const drawingKindStyle = (kind) =>
  DRAWING_KIND_STYLES[kind] || DRAWING_KIND_STYLES[DEFAULT_DRAWING_KIND];
